import styled from "styled-components";

const TooltipWrapper = styled.div`
  max-width: 260px;
`;

export default TooltipWrapper;
